import { AbstractControl, FormGroup } from '@angular/forms';

export interface IAddress {
  address_line1: string;
  address_line2: string;
  city: string;
  state: string;
  postal_code: string;
  country?: string;
}

export class Address {
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  postalCode: string;
  country?: string;

  constructor(json: IAddress) {
    this.addressLine1 = json.address_line1;
    this.addressLine2 = json.address_line2;
    this.city = json.city;
    this.state = json.state;
    this.postalCode = json.postal_code;
    this.country = json.country;
  }
}

type AddressControls = { [key in keyof IAddress]: AbstractControl };
export type AddressFormGroup = FormGroup & { value: IAddress; controls: AddressControls; };
